var styleDataHash = '597a10cd';  
export const injectCss = (() => {
  var css = `.FkvJ3{--wds-side-panel-floating-header-padding-left:18px;--wds-side-panel-footer-padding-horizontal:18px}.i--RF{--wds-color-fill-standard-tertiary-hover:rgba(0,0,0,.1)}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "modal": "FkvJ3",
  "liveSite": "i--RF"
};